<template>
  <page-wrapper :title="title">
    <div class="feature-introdiction-container">
      <sc-button
        :route="{ name: 'FeatureIntroductionCreatePage' }"
        variant="primary"
        class="mb-4"
        >เพิ่ม Feature Introduction</sc-button
      >
      <FeatureIntroductionListItem
        v-for="introductionItem in fetureIntroductionList"
        :key="introductionItem.id"
        :title="introductionItem.title"
        :platform="introductionItem.platform"
        :version="introductionItem.version"
        :created_at="introductionItem.created_at"
        :image_url="introductionItem.image_url"
      />
      <div class="wrapper text-end padding-adjust">
        <el-pagination
          :page-size="5"
          :total="total"
          :current-page="queryParams.page"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper"
import ScButton from "@/lib/components/ScButton"
import { Pagination } from "element-ui"

import FeatureIntroductionListItem from "../components/FeatureIntroductionListItem"

export default {
  components: {
    PageWrapper,
    ScButton,
    FeatureIntroductionListItem,
    "el-pagination": Pagination,
  },
  data() {
    const title = "Feature Introduction"
    const fetureIntroductionList = []
    const total = 12

    return {
      title,
      total,
      fetureIntroductionList,
    }
  },
  computed: {
    queryParams() {
      return {
        page: parseInt(this.$route.query.page, 10) || 1,
      }
    },
  },
  watch: {
    "$route.query": async function routeQueryWatcher() {
      await this.setupData()
    },
  },
  methods: {
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page },
      }

      this.$router.replace(route)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.feature-introdiction-container {
  padding: 30px;
}
</style>
